import httpClient from 'api/httpClient';
import { AxiosRequestConfig } from 'axios';
import { Contact, AddedContactToDeals, DraftContact } from 'models/Contact';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';
import { createFileFormData } from 'uploadFileUtils';

function getContacts(params?: PaginationParams) {
  return httpClient.get<PaginatedData<Contact>>('contacts', { params });
}

function createContact(data: Contact) {
  return httpClient.post<Contact>('contacts', data);
}

function updateContact(id: string, data: Partial<Contact>) {
  return httpClient.patch<Contact>(`contacts/${id}`, data);
}

function deleteContact(id: string) {
  return httpClient.delete(`contacts/${id}`);
}

function getSheetTemplate() {
  return httpClient.get<string>('contacts/sheet-template');
}

function uploadSheet(
  file: File,
  fileName: string,
  config?: AxiosRequestConfig,
) {
  const formData = createFileFormData(fileName, file);

  return httpClient.post<DraftContact[]>(
    'contacts/file-sheet-upload',
    formData,
    config,
  );
}

function bulkCreateContacts(contacts: Partial<Contact>[]) {
  return httpClient.post('contacts/bulk-create', { contacts });
}

function bulkDeleteContacts(contactIds: string[]) {
  return httpClient.delete('contacts/bulk', { data: { contactIds } });
}

function getAvailableDeals(contactIds: string[]) {
  const params = new URLSearchParams({ contactIds: contactIds.join(',') });

  return httpClient.get<AddedContactToDeals[]>('contacts/deals', { params });
}

function addContactsToDeals(contactIds: string[], dealRoomIds: string[]) {
  return httpClient.post('contacts/add-to-deals', {
    contactIds,
    dealRoomIds,
  });
}

export default {
  getContacts,
  createContact,
  updateContact,
  deleteContact,
  getSheetTemplate,
  uploadSheet,
  bulkCreateContacts,
  bulkDeleteContacts,
  getAvailableDeals,
  addContactsToDeals,
};
